// @flow

import * as React from "react";

import Tile from "../molecules/Tile";
import useViewportSizes from "../../hooks/useViewport";
import getContentReferenceTileProps from "../../utils/getContentReferenceTileProps";

type PropsType = {
    events: any,
    hideHeading?: boolean,
    context?: string,
};

const EventList = (props: PropsType): React.Node => {
    // Handle updating the nav height
    const eventListRef = React.useRef(null);
    // const [expanded, setExpanded] = React.useState(true);
    const vw = useViewportSizes().vpWidth;

    return (
        <div
            ref={eventListRef}
            className={`event-list ${
                props.hideHeading ? "event-list--hide-heading" : ""
            }`}
        >
            {!props.hideHeading ? (
                <h2 className="event-list__title">
                    {props.events.length} upcoming event
                    {props.events.length > 1 ? "s" : ""}
                </h2>
            ) : null}

            <div className="event-list__content">
                <div className="row">
                    {props.events
                        ? props.events.map((event, index) => {
                              const referenceContent =
                                  getContentReferenceTileProps(
                                      {
                                          ...event,
                                          type: "event",
                                      },
                                      props.context
                                  );

                              return (
                                  <div
                                      key={index}
                                      className="col-xs-8 col-sm-12"
                                  >
                                      <div className="event-list__content__tile">
                                          <Tile
                                              {...referenceContent}
                                              expanded={vw >= 768}
                                          />
                                      </div>
                                  </div>
                              );
                          })
                        : null}
                </div>
            </div>
        </div>
    );
};

export default EventList;
